{
  "CONTACT_PANEL": {
    "CONFIRM": {
      "YES": "OK",
      "CANCEL": "Anulează"
    },
    "NOT_AVAILABLE": "Nu este disponibil",
    "EMAIL_ADDRESS": "Adresa Email",
    "PHONE_NUMBER": "Număr de telefon",
    "WHATSAPP_USERNAME": "Nume de utilizator WhatsApp",
    "IDENTIFIER": "Identificator",
    "COPY_SUCCESSFUL": "Cod copiat în clipboard cu succes",
    "COPY_NAME": "Copiază numele",
    "COPY_REFERER": "Copiază URL",
    "COMPANY": "Companie",
    "LOCATION": "Locaţie",
    "LTV": "LTV",
    "BROWSER_LANGUAGE": "Limba browserului",
    "CONVERSATION_LANGUAGE": "Limba conversației",
    "CONVERSATION_TITLE": "Detalii conversație",
    "VIEW_PROFILE": "Vezi profil",
    "BROWSER": "Navigator",
    "OS": "Sistem de operare",
    "INITIATED_FROM": "Inițiat de la",
    "INITIATED_AT": "Iniţiat la",
    "IP_ADDRESS": "Adresă IP",
    "CREATED_AT_LABEL": "Creat",
    "NEW_MESSAGE": "Mesaj nou",
    "CONVERSATIONS": {
      "NO_RECORDS_FOUND": "Nu există conversații anterioare asociate cu acest contact.",
      "TITLE": "Conversații anterioare"
    },
    "LABELS": {
      "CONTACT": {
        "TITLE": "Etichete de contact",
        "ERROR": "Nu s-au putut actualiza etichetele"
      },
      "CONVERSATION": {
        "TITLE": "Etichete conversație",
        "ADD_BUTTON": "Adaugă etichete"
      },
      "LABEL_SELECT": {
        "TITLE": "Adaugă etichete",
        "PLACEHOLDER": "Căutare etichete",
        "NO_RESULT": "Nu s-au găsit etichete",
        "CREATE_LABEL": "Create new label"
      }
    },
    "MERGE_CONTACT": "Îmbinare contact",
    "CONTACT_ACTIONS": "Acțiuni contact",
    "MUTE_CONTACT": "Block Contact",
    "MUTE_CONTACT_DISABLED": "Nu poate fi utilizat. Întregul domeniu al contactului este blocat.",
    "UNMUTE_CONTACT": "Unblock Contact",
    "BLOCK_CONTACT_DOMAIN": "Blochează domeniul contactului",
    "UNBLOCK_CONTACT_DOMAIN": "Deblochează domeniul contactului",
    "BLOCK_CONTACT_DOMAIN_DISABLED": "Acest domeniu de contact nu poate fi blocat.",
    "BLOCK_CONTACT_DOMAIN_MESSAGE": "Blocarea domeniului va bloca toate contactele existente și viitoare pentru acel domeniu.",
    "UNBLOCK_CONTACT_DOMAIN_MESSAGE": "Deblocarea domeniului va elimina blocarea de pe toate contactele pentru acel domeniu (inclusiv cele blocate manual).",
    "BLOCK_PUBLIC_DOMAIN_TITLE": "Domeniu de email public",
    "BLOCK_PUBLIC_DOMAIN_MESSAGE": "{domain} este un domeniu de email public folosit de mulți expeditori fără legătură între ei, așa că nu poate fi blocat în întregime. Doriți să blocați doar această adresă ({email})?",
    "BLOCK_ONLY_THIS_ADDRESS": "Blochează doar această adresă",
    "MUTED_SUCCESS": "Acest contact a fost blocat cu succes. Conversațiile sale vor fi rezolvate în fundal în curând.",
    "UNMUTED_SUCCESS": "This contact is unblocked successfully.",
    "OPEN_JARABOT": "Deschide istoricul răspunsurilor AI",
    "TRANSLATE_CONVERSATION": "Traduce conversația",
    "TRANSLATE_INITIATED": "Traducerea a început. Poate dura un moment pentru conversațiile mai lungi.",
    "TRANSLATE_SUCCESS": "Traducerea conversației s-a finalizat cu succes.",
    "TRANSLATE_ERROR": "Nu s-a putut traduce conversația. Vă rugăm să încercați din nou.",
    "MOVE_CONVERSATION": "Mută conversația",
    "MOVE_CONVERSATION_MISSING_EMAIL": "Emailul contactului este necesar pentru a muta conversația într-un inbox de email",
    "MERGE_CONVERSATION": "Îmbină conversația",
    "CONTACT_DOMAIN_BLOCKED_SUCCESS": "Acest domeniu a fost blocat cu succes. Nu veți fi notificat despre nicio conversație viitoare.",
    "CONTACT_DOMAIN_UNBLOCKED_SUCCESS": "Acest domeniu a fost deblocat cu succes.",
    "SEND_TRANSCRIPT": "Trimite Transcriere",
    "EDIT_LABEL": "Editare",
    "SIDEBAR_SECTIONS": {
      "CUSTOM_ATTRIBUTES": "Editează atribut personalizat",
      "CONTACT_LABELS": "Etichete de contact",
      "PREVIOUS_CONVERSATIONS": "Conversații anterioare",
      "NO_RECORDS_FOUND": "Nu s-au găsit atribute"
    }
  },
  "EDIT_CONTACT": {
    "BUTTON_LABEL": "Editare contact",
    "TITLE": "Editare contact",
    "DESC": "Editare detalii contact"
  },
  "DELETE_CONTACT": {
    "BUTTON_LABEL": "Șterge contact",
    "TITLE": "Șterge contact",
    "DESC": "Ştergeţi datele de contact",
    "CONFIRM": {
      "TITLE": "Confirmă ștergerea",
      "MESSAGE": "Sigur doriți să ștergeți ",
      "YES": "Da, șterge",
      "NO": "Nu, păstreaza"
    },
    "API": {
      "SUCCESS_MESSAGE": "Contact șters cu succes",
      "ERROR_MESSAGE": "Nu s-a putut șterge contactul. Vă rugăm să încercați din nou mai târziu."
    }
  },
  "CONTACT_FORM": {
    "FORM": {
      "SUBMIT": "Salvează",
      "CANCEL": "Renunță",
      "AVATAR": {
        "LABEL": "Poza contact"
      },
      "NAME": {
        "PLACEHOLDER": "Introduceți numele complet al persoanei de contact",
        "LABEL": "Nume complet"
      },
      "BIO": {
        "PLACEHOLDER": "Introduceți bio pentru contact",
        "LABEL": "Biografie"
      },
      "EMAIL_ADDRESS": {
        "PLACEHOLDER": "Introduceți adresa de e-mail a persoanei de contact",
        "LABEL": "Adresa Email",
        "DUPLICATE": "Această adresă de e-mail este folosită pentru un alt contact.",
        "ERROR": "Vă rugăm să introduceți o adresă de e-mail validă."
      },
      "PHONE_NUMBER": {
        "PLACEHOLDER": "Introduceți numărul de telefon al persoanei de contact",
        "LABEL": "Număr de telefon",
        "HELP": "Numărul de telefon ar trebui să fie de format E.164 de exemplu: +1415555555 [+][codul țării][prefixul zonei][numărul de telefon local]. Puteți selecta codul de apelare din lista verticală.",
        "ERROR": "Numărul de telefon trebuie să fie gol sau in format E.164",
        "DIAL_CODE_ERROR": "Vă rugăm să selectați un cod de apelare din listă",
        "DUPLICATE": "Acest număr de telefon este utilizat pentru o altă persoană de contact."
      },
      "LOCATION": {
        "PLACEHOLDER": "Introduceți locația contactului",
        "LABEL": "Locaţie"
      },
      "COMPANY_NAME": {
        "PLACEHOLDER": "Introduceți numele companiei",
        "LABEL": "Nume companie"
      },
      "COUNTRY": {
        "PLACEHOLDER": "Introduceți numele țării",
        "LABEL": "Numele țării",
        "SELECT_PLACEHOLDER": "Selectați",
        "REMOVE": "Elimină",
        "SELECT_COUNTRY": "Selectați Țara"
      },
      "CITY": {
        "PLACEHOLDER": "Introduceți numele orașului",
        "LABEL": "Oraș"
      },
      "SOCIAL_PROFILES": {
        "FACEBOOK": {
          "PLACEHOLDER": "Introdu numele de utilizator Facebook",
          "LABEL": "Facebook"
        },
        "TWITTER": {
          "PLACEHOLDER": "Introdu numele de utilizator Facebook",
          "LABEL": "Twitter"
        },
        "LINKEDIN": {
          "PLACEHOLDER": "Introduceți numele de utilizator LinkedIn",
          "LABEL": "LinkedIn"
        },
        "GITHUB": {
          "PLACEHOLDER": "Introdu numele de utilizator Github",
          "LABEL": "Github"
        }
      },
      "UNSAVED_CHANGES": {
        "TITLE": "Modificări nesalvate",
        "DESCRIPTION": "Aveți modificări nesalvate. Doriți să le salvați înainte de a închide?",
        "CONFIRM": "Salvează",
        "CANCEL": "Renunță"
      }
    },
    "DELETE_AVATAR": {
      "API": {
        "SUCCESS_MESSAGE": "Avatar de contact șters cu succes",
        "ERROR_MESSAGE": "Avatarul de contact nu a putut fi șters. Vă rugăm să încercați din nou mai târziu."
      }
    },
    "SUCCESS_MESSAGE": "Contact salvat cu succes",
    "ERROR_MESSAGE": "A apărut o eroare, încercați din nou"
  },
  "NEW_CONVERSATION": {
    "BUTTON_LABEL": "Începe conversația",
    "TITLE": "Conversație nouă",
    "DESC": "Începe o conversație nouă prin trimiterea unui mesaj nou.",
    "NO_INBOX": "Nu s-a putut găsi un inbox pentru a iniția o nouă conversație cu acest contact.",
    "FORM": {
      "TO": {
        "LABEL": "Către"
      },
      "INBOX": {
        "LABEL": "Prin Inbox",
        "PLACEHOLDER": "Alegeți căsuța poștală sursă",
        "ERROR": "Selectați un inbox"
      },
      "SUBJECT": {
        "LABEL": "Subiect",
        "PLACEHOLDER": "Subiect",
        "ERROR": "Subiectul nu poate fi gol"
      },
      "MESSAGE": {
        "LABEL": "Mesaj",
        "PLACEHOLDER": "Scrie mesajul aici",
        "ERROR": "Mesajul nu poate fi gol"
      },
      "ATTACHMENTS": {
        "SELECT": "Choose files",
        "HELP_TEXT": "Drag and drop files here or choose files to attach"
      },
      "SUBMIT": "Trimite mesaj",
      "CANCEL": "Renunță",
      "SUCCESS_MESSAGE": "Mesaj trimis!",
      "GO_TO_CONVERSATION": "Vizualizare",
      "ERROR_MESSAGE": "Nu s-a putut trimite! Încearcă din nou"
    }
  },
  "CONTACTS_PAGE": {
    "LIST": {
      "TABLE_HEADER": {
        "SOCIAL_PROFILES": "Social Profil"
      }
    }
  },
  "CUSTOM_ATTRIBUTES": {
    "BUTTON": "Adauga atributii personalizate",
    "COPY_SUCCESSFUL": "Cod copiat în clipboard cu succes",
    "SHOW_MORE": "Show all attributes",
    "SHOW_LESS": "Show less attributes",
    "ACTIONS": {
      "COPY": "Copiază atributul",
      "DELETE": "Șterge atributul",
      "EDIT": "Editează atributul"
    },
    "ADD": {
      "TITLE": "Creează atribut personalizat",
      "DESC": "Adăugați informații personalizate acestui contact."
    },
    "FORM": {
      "CREATE": "Adaugă atribut",
      "CANCEL": "Renunță",
      "NAME": {
        "LABEL": "Nume atribut personalizat",
        "PLACEHOLDER": "Exemplu: ID-ul shopify",
        "ERROR": "Nume de atribut personalizat nevalid"
      },
      "VALUE": {
        "LABEL": "Valoare atribut",
        "PLACEHOLDER": "Ex: 11901 "
      },
      "ADD": {
        "TITLE": "Creează atribut nou ",
        "SUCCESS": "Atribut adăugat cu succes",
        "ERROR": "Imposibil de adăugat atributul. Vă rugăm să încercați din nou mai târziu"
      },
      "UPDATE": {
        "SUCCESS": "Atribut actualizat cu succes",
        "ERROR": "Imposibil de actualizat atributul. Vă rugăm să încercați din nou mai târziu"
      },
      "DELETE": {
        "SUCCESS": "Atribut sters cu succes",
        "ERROR": "Imposibil de șters atributul. Vă rugăm să încercați din nou mai târziu"
      },
      "ATTRIBUTE_SELECT": {
        "TITLE": "Adaugă atribute",
        "PLACEHOLDER": "Cauta atribute",
        "NO_RESULT": "Nu s-au găsit atribute"
      },
      "ATTRIBUTE_TYPE": {
        "LIST": {
          "PLACEHOLDER": "Selectați valoarea",
          "SEARCH_INPUT_PLACEHOLDER": "Valoarea căutării",
          "NO_RESULT": "Niciun rezultat găsit"
        }
      }
    },
    "VALIDATIONS": {
      "REQUIRED": "Este necesară o valoare validă",
      "INVALID_URL": "URL invalid",
      "INVALID_INPUT": "Invalid Input"
    }
  },
  "MERGE_CONTACTS": {
    "TITLE": "Îmbinare contacte",
    "DESCRIPTION": "Îmbinați contactele pentru a combina două profiluri într-unul, inclusiv toate atributele și conversațiile. În caz de conflict, atributele de contact primar vor avea prioritate.",
    "PRIMARY": {
      "TITLE": "Contact principal",
      "HELP_LABEL": "De eliminat"
    },
    "PARENT": {
      "TITLE": "Contact pentru îmbinare",
      "PLACEHOLDER": "Caută un contact",
      "HELP_LABEL": "De păstrat"
    },
    "SUMMARY": {
      "TITLE": "Sumar",
      "DELETE_WARNING": "Contactul <strong>{primaryContactName}</strong> va fi șters.",
      "ATTRIBUTE_WARNING": "Datele de contact ale <strong>{primaryContactName}</strong> vor fi copiate la <strong>{parentContactName}</strong>."
    },
    "SEARCH": {
      "ERROR_MESSAGE": "Something went wrong. Please try again later."
    },
    "FORM": {
      "SUBMIT": " Îmbinare contacte",
      "CANCEL": "Renunță",
      "CHILD_CONTACT": {
        "ERROR": "Selectați un contact copil pentru a imbina"
      },
      "SUCCESS_MESSAGE": "Contact unit cu succes",
      "ERROR_MESSAGE": "Contactele nu au putut fi îmbinate, încercați din nou!"
    },
    "DROPDOWN_ITEM": {
      "ID": "(ID: {identifier})"
    }
  },
  "CONTACTS_LAYOUT": {
    "HEADER": {
      "TITLE": "Contacte",
      "SEARCH_TITLE": "Search contacts",
      "SEARCH_PLACEHOLDER": "Search...",
      "MESSAGE_BUTTON": "Mesaj",
      "SEND_MESSAGE": "Trimite mesaj",
      "SHOW_DETAILS": "Detalii contact",
      "BLOCKING": "Se blochează",
      "BLOCK_CONTACT": "Block contact",
      "UNBLOCK_CONTACT": "Unblock contact",
      "BLOCK_CONTACT_MESSAGE": "Blocarea acestui contact îl va împiedica să creeze conversații noi și toate conversațiile sale existente vor fi rezolvate. Sigur doriți să blocați acest contact?",
      "UNBLOCK_CONTACT_MESSAGE": "Deblocarea acestui contact îi va permite să creeze conversații noi. Sigur doriți să deblocați acest contact?",
      "BLOCK_CONTACT_DISABLED": "Nu poate fi utilizat. Întregul domeniu al contactului este blocat.",
      "BLOCK_CONTACT_DOMAIN": "Blochează domeniul contactului",
      "UNBLOCK_CONTACT_DOMAIN": "Deblochează domeniul contactului",
      "BLOCK_CONTACT_DOMAIN_DISABLED": "Acest domeniu de contact nu poate fi blocat.",
      "BLOCK_CONTACT_DOMAIN_MESSAGE": "Blocarea domeniului va bloca toate contactele existente și viitoare pentru acel domeniu.",
      "UNBLOCK_CONTACT_DOMAIN_MESSAGE": "Deblocarea domeniului va elimina blocarea de pe toate contactele pentru acel domeniu (inclusiv cele blocate manual).",
      "BLOCK_PUBLIC_DOMAIN_TITLE": "Domeniu de email public",
      "BLOCK_PUBLIC_DOMAIN_MESSAGE": "{domain} este un domeniu de email public folosit de mulți expeditori fără legătură între ei, așa că nu poate fi blocat în întregime. Doriți să blocați doar acest contact ({email})?",
      "BLOCK_ONLY_THIS_CONTACT": "Blochează doar acest contact",
      "DIAL": "Apelează",
      "BREADCRUMB": {
        "CONTACTS": "Contacte"
      },
      "ACTIONS": {
        "CONTACT_CREATION": {
          "ADD_CONTACT": "Add contact",
          "EXPORT_CONTACT": "Export contacts",
          "IMPORT_CONTACT": "Import contacts",
          "SAVE_CONTACT": "Save contact",
          "EMAIL_ADDRESS_DUPLICATE": "Această adresă de e-mail este folosită pentru un alt contact.",
          "PHONE_NUMBER_DUPLICATE": "Acest număr de telefon este utilizat pentru o altă persoană de contact.",
          "SUCCESS_MESSAGE": "Contact salvat cu succes",
          "ERROR_MESSAGE": "Unable to save contact. Please try again later."
        },
        "BLOCK_SUCCESS_MESSAGE": "Acest contact a fost blocat cu succes. Conversațiile sale vor fi rezolvate în fundal în curând.",
        "BLOCK_ERROR_MESSAGE": "Unable to block contact. Please try again later.",
        "UNBLOCK_SUCCESS_MESSAGE": "This contact is unblocked successfully",
        "UNBLOCK_ERROR_MESSAGE": "Unable to unblock contact. Please try again later.",
        "IMPORT_CONTACT": {
          "TITLE": "Import contacts",
          "DESCRIPTION": "Importă contactele printr-un fișier CSV.",
          "DOWNLOAD_LABEL": "Descarcă un formular csv.",
          "LABEL": "Fișier CSV:",
          "CHOOSE_FILE": "Choose file",
          "CHANGE": "Schimba",
          "CANCEL": "Renunță",
          "IMPORT": "Importă",
          "SUCCESS_MESSAGE": "You will be notified via email when the import is complete.",
          "ERROR_MESSAGE": "A apărut o eroare, încercați din nou"
        },
        "EXPORT_CONTACT": {
          "TITLE": "Export contacts",
          "DESCRIPTION": "Quickly export a csv file with comprehensive details of your contacts",
          "CONFIRM": "Exportă",
          "SUCCESS_MESSAGE": "Exportul este în desfășurare, veți fi notificat prin e-mail când fișierul de export este gata de descărcare.",
          "ERROR_MESSAGE": "A apărut o eroare, încercați din nou"
        },
        "SORT_BY": {
          "LABEL": "Sortați după",
          "OPTIONS": {
            "NAME": "Nume",
            "EMAIL": "E-mail",
            "PHONE_NUMBER": "Număr de telefon",
            "COMPANY": "Companie",
            "COUNTRY": "Țară",
            "CITY": "Oraș",
            "LAST_ACTIVITY": "Ultima activitate",
            "CREATED_AT": "Creat la"
          }
        },
        "ORDER": {
          "LABEL": "Ordering",
          "OPTIONS": {
            "ASCENDING": "Ascending",
            "DESCENDING": "Descending"
          }
        },
        "FILTERS": {
          "CREATE_SEGMENT": {
            "TITLE": "Doriți să salvați acest filtru?",
            "CONFIRM": "Salvare filtru",
            "LABEL": "Nume",
            "PLACEHOLDER": "Enter the name of the filter",
            "ERROR": "Enter a valid name",
            "SUCCESS_MESSAGE": "Filter saved successfully",
            "ERROR_MESSAGE": "Unable to save filter. Please try again later."
          },
          "DELETE_SEGMENT": {
            "TITLE": "Confirmă ștergerea",
            "DESCRIPTION": "Are you sure you want to delete this filter?",
            "CONFIRM": "Da, șterge",
            "CANCEL": "No, Cancel",
            "SUCCESS_MESSAGE": "Filter deleted successfully",
            "ERROR_MESSAGE": "Unable to delete filter. Please try again later."
          }
        }
      }
    },
    "PAGINATION_FOOTER": {
      "SHOWING": "Showing {startItem} - {endItem} of {totalItems} contacts"
    },
    "FILTER": {
      "NAME": "Nume",
      "EMAIL": "E-mail",
      "PHONE_NUMBER": "Număr de telefon",
      "IDENTIFIER": "Identificator",
      "COUNTRY": "Țară",
      "CITY": "Oraș",
      "CREATED_AT": "Creat la",
      "LAST_ACTIVITY": "Ultima activitate",
      "REFERER_LINK": "Link referer",
      "BLOCKED": "Blocked",
      "BLOCKED_TRUE": "Adevărat",
      "BLOCKED_FALSE": "Fals",
      "BUTTONS": {
        "CLEAR_FILTERS": "Clear filters",
        "UPDATE_SEGMENT": "Update segment",
        "APPLY_FILTERS": "Aplicarea filtrelor",
        "ADD_FILTER": "Add filter"
      },
      "TITLE": "Filtrarea persoanelor de contact",
      "EDIT_SEGMENT": "Modifică segment",
      "SEGMENT": {
        "LABEL": "Segment name",
        "INPUT_PLACEHOLDER": "Enter the name of the segment"
      },
      "ACTIVE_FILTERS": {
        "MORE_FILTERS": "+ {count} more filters",
        "CLEAR_FILTERS": "Clear filters"
      }
    },
    "CARD": {
      "OF": "of",
      "VIEW_DETAILS": "Vezi detaliile",
      "EDIT_DETAILS_FORM": {
        "TITLE": "Editare detalii contact",
        "FORM": {
          "FIRST_NAME": {
            "PLACEHOLDER": "Enter the first name",
            "ERROR": "Prenumele este necesar."
          },
          "LAST_NAME": {
            "PLACEHOLDER": "Enter the last name"
          },
          "EMAIL_ADDRESS": {
            "PLACEHOLDER": "Enter the email address",
            "DUPLICATE": "Această adresă de e-mail este folosită pentru un alt contact.",
            "ERROR": "Vă rugăm să introduceți o adresă de e-mail validă."
          },
          "PHONE_NUMBER": {
            "PLACEHOLDER": "Enter the phone number",
            "DUPLICATE": "Acest număr de telefon este utilizat pentru o altă persoană de contact."
          },
          "CITY": {
            "PLACEHOLDER": "Introduceți numele orașului"
          },
          "COUNTRY": {
            "PLACEHOLDER": "Select country"
          },
          "BIO": {
            "PLACEHOLDER": "Enter the bio"
          },
          "COMPANY_NAME": {
            "PLACEHOLDER": "Introduceți numele companiei"
          }
        },
        "UPDATE_BUTTON": "Update contact",
        "SUCCESS_MESSAGE": "Contact updated successfully",
        "ERROR_MESSAGE": "Unable to update contact. Please try again later."
      },
      "SOCIAL_MEDIA": {
        "TITLE": "Edit social links",
        "FORM": {
          "FACEBOOK": {
            "PLACEHOLDER": "Add Facebook"
          },
          "GITHUB": {
            "PLACEHOLDER": "Add Github"
          },
          "INSTAGRAM": {
            "PLACEHOLDER": "Add Instagram"
          },
          "WHATSAPP": {
            "PLACEHOLDER": "Adaugă WhatsApp"
          },
          "LINKEDIN": {
            "PLACEHOLDER": "Add LinkedIn"
          },
          "TWITTER": {
            "PLACEHOLDER": "Add Twitter"
          }
        }
      }
    },
    "DETAILS": {
      "CREATED_AT": "Created {date}",
      "LAST_ACTIVITY": "Last active {date}",
      "DELETE_CONTACT_DESCRIPTION": "Permanently delete this contact. This action is irreversible",
      "DELETE_CONTACT": "Șterge contact",
      "DELETE_DIALOG": {
        "TITLE": "Confirmă ștergerea",
        "DESCRIPTION": "Are you sure you want to delete this {contactName} contact?",
        "CONFIRM": "Da, șterge",
        "API": {
          "SUCCESS_MESSAGE": "Contact șters cu succes",
          "ERROR_MESSAGE": "Nu s-a putut șterge contactul. Vă rugăm să încercați din nou mai târziu."
        }
      },
      "AVATAR": {
        "UPLOAD": {
          "ERROR_MESSAGE": "Could not upload avatar. Please try again later.",
          "SUCCESS_MESSAGE": "Avatar uploaded successfully"
        },
        "DELETE": {
          "SUCCESS_MESSAGE": "Avatar șters cu succes",
          "ERROR_MESSAGE": "Could not delete avatar. Please try again later."
        }
      }
    },
    "SIDEBAR": {
      "TABS": {
        "ATTRIBUTES": "Attributes",
        "HISTORY": "History",
        "NOTES": "Notițe",
        "MERGE": "Merge",
        "ORDER_HISTORY": "Comenzi recente",
        "RETINO": "Retino"
      },
      "HISTORY": {
        "EMPTY_STATE": "Nu există conversații anterioare asociate cu acest contact"
      },
      "ATTRIBUTES": {
        "SEARCH_PLACEHOLDER": "Search for attributes",
        "UNUSED_ATTRIBUTES": "{count} Used attribute | {count} Unused attributes",
        "EMPTY_STATE": "There are no contact custom attributes available in this account. You can create a custom attribute in settings.",
        "YES": "Da",
        "NO": "Nu",
        "TRIGGER": {
          "SELECT": "Selectați valoarea",
          "INPUT": "Enter value"
        },
        "VALIDATIONS": {
          "INVALID_NUMBER": "Invalid number",
          "REQUIRED": "Este necesară o valoare validă",
          "INVALID_INPUT": "Invalid input",
          "INVALID_URL": "URL invalid",
          "INVALID_DATE": "Invalid date"
        },
        "NO_ATTRIBUTES": "Nu s-au găsit atribute",
        "API": {
          "SUCCESS_MESSAGE": "Atribut actualizat cu succes",
          "DELETE_SUCCESS_MESSAGE": "Atribut sters cu succes",
          "UPDATE_ERROR": "Imposibil de actualizat atributul. Vă rugăm să încercați din nou mai târziu",
          "DELETE_ERROR": "Imposibil de șters atributul. Vă rugăm să încercați din nou mai târziu"
        }
      },
      "MERGE": {
        "TITLE": "Îmbinare contact",
        "DESCRIPTION": "Combine two profiles into one, including all attributes and conversations. In case of conflict, the primary contact’s attributes will take precedence.",
        "PRIMARY": "Contact principal",
        "PRIMARY_HELP_LABEL": "To be saved",
        "PRIMARY_REQUIRED_ERROR": "Please select a contact to merge with before proceeding",
        "PARENT": "To be merged",
        "PARENT_HELP_LABEL": "De eliminat",
        "EMPTY_STATE": "No contacts found",
        "PLACEHOLDER": "Search for primary contact",
        "SEARCH_PLACEHOLDER": "Caută un contact",
        "SEARCH_ERROR_MESSAGE": "Could not search for contacts. Please try again later.",
        "SUCCESS_MESSAGE": "Contact unit cu succes",
        "ERROR_MESSAGE": "Contactele nu au putut fi îmbinate, încercați din nou!",
        "IS_SEARCHING": "In căutare...",
        "BUTTONS": {
          "CANCEL": "Renunță",
          "CONFIRM": "Îmbinare contact"
        }
      },
      "NOTES": {
        "PLACEHOLDER": "Adaugă o notă",
        "WROTE": "scrisese",
        "YOU": "You",
        "SAVE": "Save note",
        "EMPTY_STATE": "There are no notes associated to this contact. You can add a note by typing in the box above."
      }
    },
    "EMPTY_STATE": {
      "TITLE": "No contacts found in this account",
      "SUBTITLE": "Start adding new contacts by clicking on the button below",
      "BUTTON_LABEL": "Add contact",
      "SEARCH_EMPTY_STATE_TITLE": "Niciun contact nu se potrivește cu căutarea ta 🔍",
      "LIST_EMPTY_STATE_TITLE": "No contacts available in this view 📋"
    }
  },
  "COMPOSE_NEW_CONVERSATION": {
    "TITLE": "Conversație nouă",
    "CONTACT_SEARCH": {
      "ERROR_MESSAGE": "We couldn’t complete the search. Please try again."
    },
    "FORM": {
      "GO_TO_CONVERSATION": "Vizualizare",
      "SUCCESS_MESSAGE": "The message was sent successfully!",
      "ERROR_MESSAGE": "An error occurred while creating the conversation. Please try again later.",
      "NO_INBOX_ALERT": "There are no available inboxes to start a conversation with this contact.",
      "CONTACT_SELECTOR": {
        "LABEL": "Către:",
        "TAG_INPUT_PLACEHOLDER": "Search for a contact with name, email or phone number",
        "CONTACT_CREATING": "Creating contact..."
      },
      "INBOX_SELECTOR": {
        "LABEL": "Via:",
        "BUTTON": "Show inboxes"
      },
      "EMAIL_OPTIONS": {
        "SUBJECT_LABEL": "Subiect :",
        "SUBJECT_PLACEHOLDER": "Enter your email subject here",
        "CC_LABEL": "Cc:",
        "CC_PLACEHOLDER": "Search for a contact with their email address",
        "BCC_LABEL": "Bcc:",
        "BCC_PLACEHOLDER": "Search for a contact with their email address",
        "BCC_BUTTON": "Bcc"
      },
      "MESSAGE_EDITOR": {
        "PLACEHOLDER": "Scrie mesajul aici..."
      },
      "WHATSAPP_OPTIONS": {
        "LABEL": "Select template",
        "SEARCH_PLACEHOLDER": "Search templates",
        "EMPTY_STATE": "No templates found",
        "TEMPLATE_PARSER": {
          "TEMPLATE_NAME": "WhatsApp template: {templateName}",
          "VARIABLES": "Variabile",
          "BACK": "Mergeți înapoi",
          "SEND_MESSAGE": "Trimite mesaj"
        }
      },
      "ACTION_BUTTONS": {
        "DISCARD": "Discard",
        "SEND": "Send ({keyCode})",
        "MARK_RESOLVED": "Marchează conversația nouă ca rezolvată după trimitere",
        "SAVE_DRAFT": "Salvează ciornă",
        "CREATE_AS_INTERNAL": "Creează ca conversație cu notă",
        "SEND_AND_RESOLVE_ORIGINAL": "Trimite și rezolvă conversația originală ({keyCode})"
      },
      "DISCARD": "Renunță la ciornă",
      "DISCARD_MODAL": {
        "TITLE": "Renunță la ciornă",
        "DESCRIPTION": "Sigur doriți să renunțați la această ciornă?",
        "CONFIRM": "Da, renunță",
        "CANCEL": "Nu, păstrează"
      }
    }
  }
}
